module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "this-is-the-class",
    attrs: {
      "show": _vm.showNameConfirmationModal,
      "effect": "custom"
    },
    on: {
      "update:show": function($event) {
        _vm.showNameConfirmationModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header center",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Welcome to UNOapp!")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.activeUser.first_name) ? _c('h4', [_vm._v("Can we call you "), _c('b', [_vm._v(_vm._s(_vm.activeUser.first_name))]), _vm._v("? Confirm your name below if that's right.")]) : _c('h4', [_vm._v("We didn't catch your name. Let us know what we should call you.")]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeUser.first_name),
      expression: "activeUser.first_name"
    }],
    staticClass: "form-control",
    class: {
      'edited': _vm.activeUser.first_name
    },
    attrs: {
      "type": "text",
      "id": "form_control_1",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.activeUser.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeUser, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_1"
    }
  }, [_vm._v("First Name")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeUser.last_name),
      expression: "activeUser.last_name"
    }],
    staticClass: "form-control",
    class: {
      'edited': _vm.activeUser.last_name
    },
    attrs: {
      "type": "text",
      "id": "form_control_2",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.activeUser.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activeUser, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "form_control_2"
    }
  }, [_vm._v("Last Name")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAlert($event)
      }
    }
  }, [_vm._v("Confirm")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c9d87a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmName.vue
// module id = 417
// module chunks = 1